import {inject, Injectable, signal} from '@angular/core';
import {InAppNotificationsApiService} from "../../api/services/in-app-notifications-api.service";


@Injectable({ providedIn: 'root' })
export class NotificationStore {
  private inAppNotificationsApiService = inject(InAppNotificationsApiService);

  readonly count = signal<number>(0);

  constructor() {}

  loadNotificationsCount(): void {
    this.inAppNotificationsApiService.getNotificationsCount().subscribe({
      next: (count) => this.count.set(count),
      error: (err) => {
        console.error('Failed to load notifications count', err);
        this.count.set(0);
      }
    });
  }
}
